/**
 * @format
 */

import { User } from 'state/slice/userSlice';
import { DashboardQueryParams } from '../types/dashboard.types';

/**
 * Get dashboard params based on user role
 * - root_user: no params (sees all data)
 * - admin: filtered by officeId
 * - agent: filtered by userId
 * - default: no params
 */
export const getDashboardParamsByRole = (user: User | null): DashboardQueryParams => {
  if (!user) {
    return {};
  }

  const role = user.role.toLowerCase();
  
  // Debug log to identify role issues
  console.log('getDashboardParamsByRole - User role:', user.role, '| Lowercase:', role, '| User ID:', user._id, '| Office ID:', user.officeId);

  switch (role) {
    case 'root_user':
    case 'super-admin':
    case 'superadmin':
      // Root users see all data, no filter params
      return {};

    case 'admin':
      // Admins see data for their office
      return user.officeId ? { officeId: user.officeId } : {};

    case 'agent':
      // Agents see only their own data
      return { userId: user._id };

    case 'custo':
      // Customer service - see data for their office
      return user.officeId ? { officeId: user.officeId } : {};

    default:
      // Default: restrict to user's own data for safety
      console.warn('getDashboardParamsByRole - Unrecognized role:', role);
      return { userId: user._id };
  }
};
